import { gql, makeVar, type TypePolicies, useQuery } from '@apollo/client'
import { config } from '@backoffice-frontend/common'
import type { Region } from '@backoffice-frontend/graphql'

export type SelectedRegion = Pick<Region, 'id' | 'name' | 'operatorTenant'> & {
  timeZoneId?: Region['timeZoneId']
}

export const GET_SELECTED_REGION = gql`
  query getSelectedRegion {
    getSelectedRegion @client {
      id
      name
      operatorTenant
      timeZoneId
    }
  }
`

export const useGlobalRegion = (): [SelectedRegion | undefined, boolean] => {
  const { data } = useQuery(GET_SELECTED_REGION)
  const loading = false

  return [data?.getSelectedRegion, loading]
}

export const selectedRegionVar = makeVar<SelectedRegion | undefined>(
  config.getRegion(),
)

export const selectRegion = (region?: SelectedRegion) => {
  const currentRegion = selectedRegionVar()
  if (region?.id === currentRegion?.id) {
    return
  }

  config.setRegion(region)
  selectedRegionVar(region)
}

export const MoiaRegionTypePolicies: TypePolicies = {
  Query: {
    fields: {
      getSelectedRegion: {
        read(): SelectedRegion | undefined {
          return selectedRegionVar()
        },
      },
    },
  },
}
